import Index from "container/free-shipping/free-shipping.container";

export default function FreeShiping() {
  return <Index />;
}
